import { EL_ATTRIBUTE_REFERS_DIMENSION, EL_COL_TYPE_ATTRIBUTE } from "../constants";

export const attributesAreWellDefined = (structureColumns) => {

    for(let i = 0; i < (structureColumns || []).length; i++ ) {
        const column = structureColumns[i];
        if (column.type !== EL_COL_TYPE_ATTRIBUTE) {
            continue;
        }
        const attributeDefinition = column.attributeDefinition;
        if (attributeDefinition.refers === null) {
            return false;
        } else if (attributeDefinition.refers === EL_ATTRIBUTE_REFERS_DIMENSION &&
            (attributeDefinition.dimensions || []).length === 0) {
                return false;
            }
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/components/easy-loading/attributes-step/utils.js